// composables/collections/createNormalizePart.ts
import type { PartRow } from '@/interfaces/library/partCollection'

type CanOrderPart = (part: any) => boolean

export function createNormalizePart(canOrderPart: CanOrderPart) {
  return function normalizePart(part: any): PartRow {
    const id = Number(part.id ?? part.entityId)
    const partNumber = part.partNumber ?? part.identifier ?? null

    return {
      ...part,
      type: 'part',
      id,
      partNumber,
      name: part.name ?? '',
      retailPrice: part.retailPrice ?? null,
      wholesalePrice: part.wholesalePrice ?? null,
      discountPrice: part.discountPrice ?? null,
      quantity: part.quantity ?? null,
      uom: part.uom ?? null,
      isOrderable: canOrderPart({ ...part, id, partNumber })
    }
  }
}
